import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { AuthState } from "../../../../context/auth/auth/reducer";
import { Event } from "../../../../data/interfaces";
import { trackParticipantToEvent } from "../../../../context/events/action";
import { mapEventToSnippet } from "../../../../utils/mapping";
import _environment from "../../../../_environment/_environment";
// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
  event: Event;
  roomInitializedCallback: (res: boolean) => void;
}

declare const window: any;

const EventDetailJitsiView = ({ event, roomInitializedCallback, ...restProps }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  const jitsiContainerId = "jitsi-container";

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------
  // Jitsi instance
  const [jitsi, setJitsi] = React.useState<any>(null);

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------
  const { user } = useSelector(({ authReducer }: { authReducer: AuthState }) => {
    return authReducer;
  });

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * Isn't available as an NPM module. The script takes an onload callback,
   * which runs once the script has been loaded and executed.
   * In order to convert this into a promise,
   * we pass it the resolve method of an empty promise.
   * @function
   */
  const loadJitsiScript = () => {
    let resolveLoadJitsiScriptPromise = null;

    const loadJitsiScriptPromise = new Promise((resolve) => {
      resolveLoadJitsiScriptPromise = resolve;
    });

    const script = document.createElement("script");
    script.src = `${_environment.jitsiURL}/external_api.js`;
    script.async = true;
    script.onload = resolveLoadJitsiScriptPromise;
    document.body.appendChild(script);

    return loadJitsiScriptPromise;
  };

  /**
   * Remove Jisti Meet API script
   * @function
   */
  const unloadJitsiScript = () => {
    jitsi?.dispose?.();
  };

  /**
   * Adds a class named JitsiMeetExternalAPI to the global window object.
   * Instantiating this class loads the Jitsi iframe and returns an API object,
   * which we can later be used to customise and control the Jitsi interface.
   * @function
   * @async
   */
  const initialiseJitsi = async () => {
    if (user) {
      if (!window.JitsiMeetExternalAPI) {
        await loadJitsiScript();
      }
      const _jitsi = new window.JitsiMeetExternalAPI("meet.jit.si", {
        parentNode: document.getElementById(jitsiContainerId),
        roomName: event.jitsi?.meeting_name.split("https://meet.jit.si/").pop(),
        hosts: {
          domain: "meet.jit.si",
          anonymousdomain: "localhost:3000",
        },
        configOverwrite: {
          startWithAudioMuted: true,
          enableUserRolesBasedOnToken: true, // TODO: VEDERE SE GESTISCE I RUOLI
          enableFeaturesBasedOnToken: true,
        },
        interfaceConfigOverwrite: {},
        userInfo: {
          email: user.email,
          displayName: `${user.firstname} ${user.lastname}`,
        },
      });

      _jitsi.executeCommand("avatarUrl", user.profile_image_url);

      setJitsi(_jitsi);
    }
  };

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    // init component
    console.log("[EventDetailJitsiView] init");
    roomInitializedCallback(true);
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    // destroy component
    console.log("[EventDetailJitsiView] destroy");
    unloadJitsiScript();
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  /**
   * Hook to user in order to initialize Jitsi provider
   */
  useEffect(() => {
    if (user) {
      initialiseJitsi();
    }
  }, [user]);

  /**
   * Hook to jitsi in order to listen on it's events
   */
  useEffect(() => {
    if (jitsi) {
      jitsi.addEventListener("videoConferenceLeft", (data: any) => {
        jitsi.dispose();
        initialiseJitsi();
      });

      jitsi.addEventListener("videoConferenceJoined", (data: any) => {
        console.log("videoConferenceJoined", data);

        // Track participant on firestore
        trackParticipantToEvent(user, mapEventToSnippet(event));
      });
    }
  }, [jitsi]);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return <div id={jitsiContainerId}/>;
};
export default EventDetailJitsiView;
